import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import { useUniqueID } from "@xo-union/react-unique-id";
import useSet from "../utils/useSet.js";
const ModalHeaderContext = /*#__PURE__*/React.createContext({
  add: noop,
  delete: noop
});

const ModalHeaderDescribeIDsProvider = _ref => {
  let {
    children
  } = _ref;
  const [headerIDsSet, headerIDsSetActions] = useSet();
  const describeIDs = headerIDsSet.size === 0 ? undefined : [...headerIDsSet].join(' ');
  return /*#__PURE__*/React.createElement(ModalHeaderContext.Provider, {
    value: headerIDsSetActions
  }, children(describeIDs));
};

process.env.NODE_ENV !== "production" ? ModalHeaderDescribeIDsProvider.propTypes = {
  children: PropTypes.func
} : void 0;
/**
 * Render a header that will be automatically associated via `aria-labelledby` with parent ModalContainer
 *
 * Passes ref to underlying element
 */

const ModalHeader = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    as: Type,
    active,
    id: idProp,
    ...props
  } = _ref2;
  const id = useUniqueID(idProp);
  const headerIDsSetActions = React.useContext(ModalHeaderContext);
  React.useEffect(() => {
    if (active) {
      headerIDsSetActions.add(id);
    } else {
      headerIDsSetActions.delete(id);
    }

    return () => headerIDsSetActions.delete(id);
  }, [active, id, headerIDsSetActions]);
  return /*#__PURE__*/React.createElement(Type, _extends({
    ref: ref,
    id: id
  }, props));
});
ModalHeader.defaultProps = {
  as: 'h1',
  active: true
};
process.env.NODE_ENV !== "production" ? ModalHeader.propTypes = {
  /**
   * Override the id
   */
  id: PropTypes.string,

  /**
   * Whether or not header is active. This is useful in cases where a modal screen with a header is animated. Rendering the header won't
   * automatically associate the underlying element with its parent Modal unless `active=true`
   */
  active: PropTypes.bool,

  /**
   * Underlying element type to render
   */
  as: PropTypes.elementType
} : void 0;
ModalHeader.displayName = 'ModalHeader';
export { ModalHeader, ModalHeaderDescribeIDsProvider };